/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvalidDataReportType {
    WRONG_NUMBER = 'WrongNumber',
    WRONG_ADDRESS = 'WrongAddress',
    WRONG_PHASE = 'WrongPhase',
}
